import React, { useContext, useEffect, useState } from "react";
import FilteringComponenet from "../filtering-component/hoa-filtering-comp";
import TableLayout from '../table-layout/hoa-table-layout';

import config from "../../hoa-config";
import "./hoa-email-dashboard-style.scss";

import SuccessMessage from "../success-message/hoa-success-message";
import { GlobalContext } from '../../context/hoa-global-context';
import dashboardServices from "../../services/hoa-dashboard-api-service";
import datastore from "../../store/hoa-datastore";
import EmailAssignDocument from "./hoa-email-assign-document";
import AssignPropertyModal from "./hoa-email-assign-property-modal";

export default function EmailsDashboard() {
    const { selectedValues, email, updateEmailData, updateSelectedValues, updateView, view:views } = useContext<any>(GlobalContext);

    const [view, setView] = useState("list");

    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [previousMail, setPreviousMail] = useState(JSON.parse(JSON.stringify(selectedValues)));
    const [modalOpen, toggleModalOpen] = useState(false);
    const [currentAssignedProperty, setCurrentAssignedProperty] = useState(null);
    const [assignedPropertyList, setAssignedPropertyList] = useState([]);
    const [deletedAssignedPropertyList, setDeletedAssignedPropertyList] = useState([]);

    const headers = config.dashboard['Emails']?.tableLayout?.title;
    const columns = config.dashboard['Emails']?.tableLayout?.columns;
    const filteringTitle = config.dashboard['Emails']?.filterComponent?.title;
    const filteringSubTitle = config.dashboard['Emails']?.filterComponent?.subTitle;

    const getEmails = async (numberOfEmails: number, pageNo: number) => {
		const { data } = await dashboardServices.getEmails(numberOfEmails, pageNo, email.options);
		return {
            data: data.emails,
            count: data.parseCount
        };
	};

    const updateMail = async (objectId: string, newStatus: string) => {
        if(!objectId || !newStatus) {
            return;
        }
        let data = JSON.parse(JSON.stringify(email.data));
        let updateIndex = 0;
        data.find((value: any, index: number) => {
            if(value.objectId === objectId){
                updateIndex = index;
            }
        });
        var updatedEmail = JSON.parse(JSON.stringify(data[updateIndex]));
        if(newStatus === updatedEmail.status){
            return;
        }
        updatedEmail.status = newStatus;
        updatedEmail.lastUpdatedBy = datastore.ownerInformation.email;
        const result = await dashboardServices.updateEmailStatus(updatedEmail);

        if(result.status == 200 && result.data) {
            data[updateIndex] = updatedEmail;
            updateEmailData({
                ...email,
                data
            });
            let logsData = {
                action: newStatus,
                updatedBy: datastore.ownerInformation.email,
                email: updatedEmail,
                emailId: objectId
            }
            dashboardServices.createMailLog(logsData);
        }
    }

    useEffect(() => {
        if (views === 'back-to-list') {
            setView('list');
            updateView('list');
            return;
        } 
        updateView(view);
    },[view,views === 'back-to-list']);

    return (
        <>
            {
                view === 'list' ?
                    <>
                        <FilteringComponenet 
                            onAddClick={setView} 
                            title={filteringTitle} 
                            subTitle={filteringSubTitle} 
                            tagType={'Email'}
                        />
                        <TableLayout
                            fetchResult={getEmails}
                            headers={headers}
                            columns={columns}
                            tagType={"Email"}
                            updateView={setView} 
                            updateMail={updateMail}
                            updateSelectedValues={updateSelectedValues}
					    />
                    </>
                    :<>
                        <EmailAssignDocument
                            previousMail={previousMail}
                            setSuccess={setSuccess}
                            view={view}
                            setView={setView}
                            toggleModalOpen={toggleModalOpen}
                            selectedValues={selectedValues}
                            updateSelectedValues={updateSelectedValues}
                            currentAssignedProperty={currentAssignedProperty}
                            setCurrentAssignedProperty={setCurrentAssignedProperty}
                            assignedPropertyList={assignedPropertyList}
                            setAssignedPropertyList={setAssignedPropertyList}
                            deletedAssignedPropertyList={deletedAssignedPropertyList}
                            setDeletedAssignedPropertyList={setDeletedAssignedPropertyList}
                        />
                        <AssignPropertyModal
                            modalOpen={modalOpen}
                            toggleModalOpen={toggleModalOpen}
                            assignedProperty={currentAssignedProperty}
                            setAssignedProperty={setCurrentAssignedProperty}
                        />
                    </>
            }

            <SuccessMessage
                success={success}
                setSuccess={setSuccess}
                message={message}
            />
        </>
    )

}